import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './TagList.css';
import * as api from '../../../../api';
import { ROUTING } from '../../../../constants';

// todo - show some 'fetching' state?

class TagList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      tags: [],
    };
  }

  componentDidMount() {
    api.getTagList().then((data) => {
      this.setState({
        fetching: false,
        tags: data,
      });
    }).catch(() => {
      // todo - solve error state
    });
  }

  render() {
    const { currentTag, open } = this.props;
    const tags = this.state.tags.map(tag => (
      <Link
        key={encodeURIComponent(tag)}
        className={`tag ${tag === currentTag ? 'selected' : ''}`}
        to={`${ROUTING.TAG}/${tag}`}
      >
        {tag}
      </Link>
    ));

    return (
      <div className={`wrap-tags ${open ? 'open' : 'closed'}`}>
        <div className="tag-list">
          {tags}
        </div>
      </div>
    );
  }
}

export default TagList;



// WEBPACK FOOTER //
// ./src/components/App/Tag/TagList/TagList.js